// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Orders from '../components/Orders';
import {actions as OrdersActions} from '../duck';
import {actions as OrderActions} from '../../order/duck';
import {actions as SalesProcessActions} from '../../configure/sales-process/duck';
import {actions as AccountsActions} from '../../configure/accounts/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    orders: state.orders.orders,
    pagination: state.orders.pagination,
    queryFilter: state.orders.queryFilter,
    isFetching: state.orders.isFetching,
    isSaving: state.order.isSaving,
    selectedStates: state.orders.selectedStates,
    store: state.store.store,
    currency: state.currency.currency,
    user: state.auth.user,
    dueInformation: state.tiersList.dueInformation,
    orderStockErrors: state.order.orderStockErrors,
    fetchOrderStockErrorsSuccess: state.order.fetchOrderStockErrorsSuccess,
    updateOrderStateSuccess: state.order.updateOrderStateSuccess,
    updateOrderCollaboratorSuccess: state.order.updateOrderCollaboratorSuccess,
    updateOrderStateError: state.order.updateOrderStateError,
    orderStateMessages: state.salesProcessConfig.orderStateMessages,
    collaborators: state.accountsConfig.collaborators,
    tempCollaborators: state.orders.tempCollaborators,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...OrdersActions,
        ...OrderActions,
        ...SalesProcessActions,
        ...AccountsActions,
      },
      dispatch
    )
)(Orders);
